function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import MersenneTwister from 'mersenne-twister';
import colors from '../colors';

const Canvas = ({
  children,
  color,
  size,
  className = '',
  style = {},
  ...rest
}) => /*#__PURE__*/React.createElement("div", _extends({
  className: className,
  style: {
    borderRadius: '50px',
    display: 'inline-block',
    overflow: 'hidden',
    margin: 0,
    padding: 0,
    backgroundColor: color,
    height: size,
    width: size,
    ...style
  }
}, rest), children);

const Avatar = ({
  size,
  seed,
  className = '',
  style = {},
  svgStyle = {},
  ...rest
}) => {
  const avatarColors = [colors['purple-200'], colors['purple-400'], colors['purple-500'], colors['purple-600'], colors['blue-400'], colors['blue-500'], colors['blue-600']];
  const generator = new MersenneTwister(seed);

  const genColor = avatarColors => {
    const idx = Math.floor(avatarColors.length * generator.random());
    const color = avatarColors.splice(idx, 1)[0];
    return color;
  };

  const hueShift = (avatarColors, generator) => {
    const wobble = 30;
    const amount = generator.random() * 30 - wobble / 2;
    return avatarColors.map(hex => {
      const color = Color(hex);
      color.rotate(amount);
      return color.hex();
    });
  };

  const genShape = (remainingColors, size, i, total) => {
    const center = size / 2;
    const firstRot = generator.random();
    const angle = Math.PI * 2 * firstRot;
    const velocity = size / total * generator.random() + i * size / total;
    const tx = Math.cos(angle) * velocity;
    const ty = Math.sin(angle) * velocity;
    const translate = 'translate(' + tx + ' ' + ty + ')'; // Third random is a shape rotation on top of all of that.

    const secondRot = generator.random();
    const rot = firstRot * 360 + secondRot * 180;
    const rotate = 'rotate(' + rot.toFixed(1) + ' ' + center + ' ' + center + ')';
    const transform = translate + ' ' + rotate;
    const fill = genColor(remainingColors);
    return /*#__PURE__*/React.createElement("rect", {
      key: i,
      x: "0",
      y: "0",
      rx: "0",
      ry: "0",
      height: size,
      width: size,
      transform: transform,
      fill: fill
    });
  };

  const shapeCount = 4;
  const remainingColors = hueShift(avatarColors.slice(), generator);
  const shapesArr = Array(shapeCount).fill();
  return /*#__PURE__*/React.createElement(Canvas, _extends({
    color: genColor(remainingColors),
    size: size,
    style: style,
    className: className || 'canvas'
  }, rest), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    height: size,
    width: size,
    style: svgStyle
  }, shapesArr.map((s, i) => genShape(remainingColors, size, i, shapeCount - 1))));
};

const EthAvatar = ({
  address = '0x0000000000000000000000000000000000000000',
  size = 100,
  className = '',
  style = {},
  svgStyle = {},
  ...props
}) => {
  if (['', null, undefined].includes(address)) address = '0x0000000000000000000000000000000000000000';
  return /*#__PURE__*/React.createElement(Avatar, _extends({
    seed: parseInt(address.slice(2, 10), 16),
    size: size,
    className: className,
    style: style,
    svgStyle: svgStyle
  }, props));
};

EthAvatar.propTypes = {
  address: PropTypes.string,
  size: PropTypes.number,
  svgStyle: PropTypes.object,
  className: PropTypes.string,
  style: PropTypes.object
};
export default EthAvatar;